<div class="notification-info">
    <label class="notification-label"
        (click)="toggleSwitchEvent(); $event.stopPropagation();">
        <div class="label-text" [ngClass]="{ 'active-label': isActive }">
            {{ subtitle(isActive ? 1447 : 924) }}
        </div>
        <notification-switch [isActive]="isActive"></notification-switch>
    </label>
    <div class="notification-time">
        {{ timeText }}
    </div>
</div>
